import { type Coupon } from '@hooks-api/types/dataModel/coupon'
import { type ECommerceProduct } from '@hooks-api/types/dataModel/products'
import { Tab } from '@pets-ui/Tab/Tab'
import { TabList, type TabListProps } from '@pets-ui/TabList/TabList'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { useState } from 'react'
import { CouponProductSelectorItem, type CouponProductToggleVariationHandler } from './CouponProductSelectorItem'

const A_ASCII = 65

export interface CouponSpecificProductsMapItem {
  coupon_id: Coupon['id']
  product_groups: ECommerceProduct[][]
}
export interface CouponProductSelectorProps {
  couponSpecificProductsMapItem: CouponSpecificProductsMapItem
  onToggleCouponProduct?: CouponProductToggleVariationHandler
}

export const CouponProductSelector = (props: CouponProductSelectorProps) => {
  const { couponSpecificProductsMapItem, onToggleCouponProduct } = props
  const [selectedProductsGroupIndex, setSelectedProductsGroupIndex] = useState(0)
  const selectedProductsGroup = couponSpecificProductsMapItem.product_groups[selectedProductsGroupIndex] ?? []

  const handleChange: TabListProps<number>['onChange'] = (_, newValue) => {
    if (newValue === undefined) return
    setSelectedProductsGroupIndex(newValue)
  }

  const renderTabList = () => {
    return (
      <TabList variant="fullWidth" onChange={handleChange} value={selectedProductsGroupIndex}>
        {couponSpecificProductsMapItem.product_groups.map((_, index) => (
          <Tab key={index} value={index}>
            {String.fromCharCode(A_ASCII + index)}
            {' '}
            區
          </Tab>
        ))}
      </TabList>
    )
  }

  return (
    <VStack gap={2}>
      {couponSpecificProductsMapItem.product_groups.length > 1 && renderTabList()}
      {selectedProductsGroup.length > 0
        ? (
          <VStack borderWidth={1} borderRadius={8} borderStyle="solid" borderColor={colors.grey300}>
            <CouponProductSelectorItem
              groupIndex={selectedProductsGroupIndex}
              products={selectedProductsGroup}
              onToggleCouponProduct={onToggleCouponProduct}
            />
          </VStack>
        )
        : (
          <Text variant="body" color={colors.grey800}>
            全館商品
            {' '}
            <Text color={colors.grey700} component="span" variant="caption">(常溫商品、冷凍商品、寄倉商品)</Text>
          </Text>
        )}
    </VStack>
  )
}
